import React from 'react';
import Layout from '../components/Layout';
import CarouselSection from '../components/HomePage/CarouselSection';
import Feature from '../components/HomePage/Feature';
import AboutUs from '../components/HomePage/AboutUs';
import Topper from '../components/HomePage/Topper';
import Notices from '../components/HomePage/Notices';
import Facilities from '../components/HomePage/Facilities';
import SchoolAwards from '../components/HomePage/SchoolAwards';
import Gallery from '../components/HomePage/Gallery';
import VideoGallery from '../components/HomePage/VideoGallery';
import Message from '../components/HomePage/Message';
import Popup from '../components/Popup';
import { useHomeInit } from '../hooks/useAppInit';

export default function Home() {
  const { openPopup, popupData, closePopup } = useHomeInit();

  return (
    <Layout>
      <CarouselSection />
      <Feature />
      <AboutUs />
      <Topper />
      <Notices />
      <Facilities />
      <SchoolAwards />
      <Message />
      <Gallery />
      <VideoGallery />
      <Popup open={openPopup} data={popupData} onClose={closePopup} />
    </Layout>
  );
}
